module.exports = __webpack_public_path__ + "923e1afc04248ed0f97b801b09e034f6.jpg";